import Snackbar from '@/types/app/snackbar';
import { AppState } from './types';

export default {
  getSnackbar(state: AppState): Snackbar {
    return state.snackbar;
  },
  getOverlay(state: AppState): boolean {
    return state.overlay;
  }
};
